import React from 'react';
import { Star } from 'lucide-react';
export function StatsBar() {
  return <div className="bg-lightgray border-y border-border py-8" data-id="element-249">
      <div className="max-w-6xl mx-auto px-4" data-id="element-250">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center divide-x-0 md:divide-x divide-border" data-id="element-251">
          <div className="flex flex-col items-center justify-center" data-id="element-252">
            <span className="text-2xl md:text-4xl font-heading font-bold text-white mb-1" data-id="element-253">
              +1,000
            </span>
            <span className="text-xs md:text-sm text-muted uppercase tracking-wider font-bold" data-id="element-254">
              Families Trust Us
            </span>
          </div>
          <div className="flex flex-col items-center justify-center" data-id="element-255">
            <span className="text-2xl md:text-4xl font-heading font-bold text-white mb-1" data-id="element-256">
              6
            </span>
            <span className="text-xs md:text-sm text-muted uppercase tracking-wider font-bold" data-id="element-257">
              Volumes Included
            </span>
          </div>
          <div className="flex flex-col items-center justify-center" data-id="element-258">
            <div className="flex items-center justify-center mb-1" data-id="element-259">
              <span className="text-2xl md:text-4xl font-heading font-bold text-white mr-2" data-id="element-260">
                4.9/5
              </span>
              <div className="flex" data-id="element-261">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 md:w-5 md:h-5 text-gold fill-gold" data-id="element-262" />)}
              </div>
            </div>
            <span className="text-xs md:text-sm text-muted uppercase tracking-wider font-bold" data-id="element-263">
              Rating
            </span>
          </div>
          <div className="flex flex-col items-center justify-center" data-id="element-264">
            <span className="text-2xl md:text-4xl font-heading font-bold text-white mb-1" data-id="element-265">
              🌍
            </span>
            <span className="text-xs md:text-sm text-muted uppercase tracking-wider font-bold" data-id="element-266">
              Families Worldwide
            </span>
          </div>
        </div>
      </div>
    </div>;
}